/**
 * Provider for "referrer" key
 * @module
 */
var DocumentEnv = require('core/env/document');
var RedirectUtil = require('core/utils/redirect');

module.exports = {
  provides: 'referrer',
  shouldTrack: true,

  isSticky: true,

  getter: [
    function() {
      var referrer = RedirectUtil.getReferrer() || DocumentEnv.getReferrer();
      // return null if no referrer (more semantic meaning)
      if (referrer === '') {
        referrer = null;
      }
      return referrer;
    },
  ],
};
